export default __webpack_public_path__ + "static/media/autoFill.92cae34b.jpg";